import { extendRequiredParameter } from './apply.ts'
import { classNames } from './data/class-names.ts'
import { Completions } from './types.ts'

export function buildClassCompletions(completions: Completions) {
  for (const item of classNames) {
    completions.classes.push({
      type: 'pkg',
      label: item,
      extend: extendRequiredParameter,
    })
  }
}
